<template lang="pug">
div
	a(@click="openPreview") {{ linkText }}

	b-modal#modalxl(v-if="showProjectPreview", v-model="showProjectPreview", hide-footer size="lg", :title="titleName")
		project-preview.project-preview(:proj-id="project.projId", v-if="!isLegacy")
		print-legacy.project-preview(:proj-id="project.projId", v-if="isLegacy")
		.content-btn( style="width: 100%; display: flex; justify-content:center;")
			a(@click="showProjectPreview = false")
				easyBtn(btnText="Close")
</template>

<script>
import ProjectPreview from 'App/project/preview-component.vue'
import PrintLegacy from 'App/project/print-legacy.vue'
import easyBtn from 'Common/components/easy-btn.vue'

export default {
	name: 'project-preview-popup',
	props: ['project', 'linkText'],
	data () {
		return {
			showProjectPreview: false,
			titleName: '# ' + this.project.projId + ' ' + this.project.name,
			isLegacy: false
		}
	},
	components: {
		ProjectPreview,
		PrintLegacy,
		easyBtn
	},
	methods: {
		openPreview () {
			this.isLegacy = (this.project.projId < 10000)
			this.showProjectPreview = true
			// this.$router.push({name: 'projectPreview', params: { projId: this.params.data.projId }})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/common/components/project-report-popup.vue